import React from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import {
    faBoxOpen,
    faCircleCheck,
    faCube,
    faEye,
    faLink,
    faLocationDot,
    faTag
}
from "@fortawesome/free-solid-svg-icons";


export default function PotentialAssetDetail({
    potentialAsset
})
{

    //--------------------------------------------------------
    // Formatting
    //--------------------------------------------------------

    function displayValue(value)
    {
        if(
            value === null
            ||
            value === undefined
            ||
            value === ""
        )
        {
            return "—";
        }

        return value;
    }


    function formatConfidence(value)
    {
        if(
            value === null
            ||
            value === undefined
        )
        {
            return "—";
        }

        return value + "%";
    }


    function statusColour(status)
    {
        switch((status || "").toUpperCase())
        {
            case "APPROVED":
                return "#20a15a";

            case "MATCHED":
                return "#2563eb";

            case "REJECTED":
            case "IGNORED":
                return "#ef3f45";

            case "NEW":
                return "#f2b321";

            default:
                return "#7d8796";
        }
    }


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    if(!potentialAsset)
    {
        return null;
    }


    return (
        <>
            <div style={detailHeaderStyle}>

                <div style={eyebrowStyle}>
                    POTENTIAL ASSET
                </div>

                <h1 style={titleStyle}>
                    {
                        potentialAsset.name
                        ||
                        "Detected Asset"
                    }
                </h1>


                <div style={badgeRowStyle}>

                    <span
                        style={{
                            ...statusBadgeStyle,

                            background:
                                statusColour(
                                    potentialAsset.status
                                )
                        }}
                    >
                        {
                            potentialAsset.status
                            ||
                            "NEW"
                        }
                    </span>


                    {
                        potentialAsset.matchedAssetId
                        &&
                        <span style={matchedBadgeStyle}>
                            MATCHED ASSET
                        </span>
                    }

                </div>

            </div>


            <div style={detailBodyStyle}>

                <DetailBlock
                    icon={faEye}
                    title="AI detection"
                >
                    {
                        potentialAsset.description
                        ||
                        "No asset description available."
                    }
                </DetailBlock>


                <div style={metricGridStyle}>

                    <Metric
                        label="Confidence"
                        value={
                            formatConfidence(
                                potentialAsset.confidence
                            )
                        }
                    />

                    <Metric
                        label="Status"
                        value={
                            displayValue(
                                potentialAsset.status
                            )
                        }
                    />

                    <Metric
                        label="Entity"
                        value={
                            potentialAsset.entityId
                            ?
                            "#" + potentialAsset.entityId
                            :
                            "Not classified"
                        }
                    />

                    <Metric
                        label="Asset match"
                        value={
                            potentialAsset.matchedAssetId
                            ?
                            "#" + potentialAsset.matchedAssetId
                            :
                            "Not matched"
                        }
                    />

                </div>


                <DetailBlock
                    icon={faCube}
                    title="Asset identification"
                >

                    <DetailRow
                        icon={faTag}
                        label="Detected name"
                        value={
                            displayValue(
                                potentialAsset.name
                            )
                        }
                    />

                    <DetailRow
                        icon={faCircleCheck}
                        label="Status"
                        value={
                            displayValue(
                                potentialAsset.status
                            )
                        }
                    />

                    <DetailRow
                        icon={faLink}
                        label="Entity"
                        value={
                            potentialAsset.entityId
                            ?
                            potentialAsset.entityId
                            :
                            "None"
                        }
                    />

                    <DetailRow
                        icon={faBoxOpen}
                        label="Matched asset"
                        value={
                            potentialAsset.matchedAssetId
                            ?
                            potentialAsset.matchedAssetId
                            :
                            "None"
                        }
                    />

                </DetailBlock>


                {
                    (
                        potentialAsset.imageX != null
                        ||
                        potentialAsset.imageY != null
                        ||
                        potentialAsset.imageWidth != null
                        ||
                        potentialAsset.imageHeight != null
                    )
                    &&
                    <DetailBlock
                        icon={faLocationDot}
                        title="Detection location"
                    >

                        <DetailRow
                            label="X"
                            value={
                                displayValue(
                                    potentialAsset.imageX
                                )
                            }
                        />

                        <DetailRow
                            label="Y"
                            value={
                                displayValue(
                                    potentialAsset.imageY
                                )
                            }
                        />

                        <DetailRow
                            label="Width"
                            value={
                                displayValue(
                                    potentialAsset.imageWidth
                                )
                            }
                        />

                        <DetailRow
                            label="Height"
                            value={
                                displayValue(
                                    potentialAsset.imageHeight
                                )
                            }
                        />

                    </DetailBlock>
                }

            </div>
        </>
    );
}


//--------------------------------------------------------
// Detail block
//--------------------------------------------------------

function DetailBlock({
    icon,
    title,
    children
})
{
    return (
        <div style={detailBlockStyle}>

            <div style={blockHeadingStyle}>

                {
                    icon
                    &&
                    <FontAwesomeIcon
                        icon={icon}
                        style={blockIconStyle}
                    />
                }

                {title}

            </div>

            <div style={blockContentStyle}>
                {children}
            </div>

        </div>
    );
}


//--------------------------------------------------------
// Metric
//--------------------------------------------------------

function Metric({
    label,
    value
})
{
    return (
        <div style={metricStyle}>

            <div style={metricLabelStyle}>
                {label}
            </div>

            <div style={metricValueStyle}>
                {value}
            </div>

        </div>
    );
}


//--------------------------------------------------------
// Detail row
//--------------------------------------------------------

function DetailRow({
    icon,
    label,
    value
})
{
    return (
        <div style={detailRowStyle}>

            <div style={rowLabelStyle}>

                {
                    icon
                    &&
                    <FontAwesomeIcon
                        icon={icon}
                        style={rowIconStyle}
                    />
                }

                {label}

            </div>

            <div style={rowValueStyle}>
                {value}
            </div>

        </div>
    );
}


//--------------------------------------------------------
// Header styles
//--------------------------------------------------------

const detailHeaderStyle =
{
    padding: "24px 24px 22px 24px",

    color: "#ffffff",

    background:
        "linear-gradient(145deg, #292e35 0%, #171a1f 55%, #101215 100%)",

    borderBottom:
        "1px solid rgba(255,255,255,0.08)",

    boxShadow:
        "0 10px 24px rgba(20, 26, 34, 0.16)"
};


const eyebrowStyle =
{
    marginBottom: "8px",

    color: "#8fa0b8",

    fontSize: "10px",
    fontWeight: "800",
    letterSpacing: "1.7px"
};


const titleStyle =
{
    margin: "0 0 16px 0",

    color: "#ffffff",

    fontSize: "22px",
    lineHeight: "1.28",
    fontWeight: "750"
};


const badgeRowStyle =
{
    display: "flex",
    flexWrap: "wrap",
    gap: "7px"
};


const statusBadgeStyle =
{
    padding: "6px 10px",

    color: "#ffffff",

    borderRadius: "6px",

    fontSize: "10px",
    fontWeight: "800",
    letterSpacing: "0.7px",

    textTransform: "uppercase"
};


const matchedBadgeStyle =
{
    padding: "6px 10px",

    color: "#d2dae5",

    background:
        "rgba(255,255,255,0.08)",

    border:
        "1px solid rgba(255,255,255,0.13)",

    borderRadius: "6px",

    fontSize: "10px",
    fontWeight: "700",
    letterSpacing: "0.4px"
};


//--------------------------------------------------------
// Body styles
//--------------------------------------------------------

const detailBodyStyle =
{
    flex: 1,

    padding: "22px 24px 35px 24px",

    overflowY: "auto",

    background: "#ffffff"
};


const detailBlockStyle =
{
    marginBottom: "24px"
};


const blockHeadingStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "8px",

    marginBottom: "10px",

    color: "#292f38",

    fontSize: "12px",
    fontWeight: "750",
    letterSpacing: "0.2px"
};


const blockIconStyle =
{
    width: "14px",

    color: "#477df5"
};


const blockContentStyle =
{
    color: "#606b7a",

    fontSize: "12.5px",
    lineHeight: "1.65"
};


//--------------------------------------------------------
// Metric styles
//--------------------------------------------------------

const metricGridStyle =
{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "9px",

    marginBottom: "25px"
};


const metricStyle =
{
    minWidth: 0,

    padding: "13px",

    background:
        "linear-gradient(145deg, #f7f8fa 0%, #f0f2f5 100%)",

    border: "1px solid #e0e4e9",
    borderRadius: "9px"
};


const metricLabelStyle =
{
    marginBottom: "6px",

    overflow: "hidden",

    color: "#8490a0",

    fontSize: "9px",
    fontWeight: "800",
    letterSpacing: "0.8px",

    textOverflow: "ellipsis",
    textTransform: "uppercase",
    whiteSpace: "nowrap"
};


const metricValueStyle =
{
    overflow: "hidden",

    color: "#272d36",

    fontSize: "14px",
    fontWeight: "750",

    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};


//--------------------------------------------------------
// Row styles
//--------------------------------------------------------

const detailRowStyle =
{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",

    gap: "12px",

    padding: "10px 0",

    borderBottom:
        "1px solid #e8ebef"
};


const rowLabelStyle =
{
    display: "flex",
    alignItems: "center",
    gap: "8px",

    color: "#737f8f",

    fontSize: "11.5px"
};


const rowIconStyle =
{
    width: "12px",

    color: "#8a98aa"
};


const rowValueStyle =
{
    maxWidth: "58%",

    overflow: "hidden",

    color: "#29303a",

    fontSize: "11.5px",
    fontWeight: "700",

    textAlign: "right",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};